import { cn } from "@/lib/utils";

export const BorderPositions = {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_LEFT: "bottom-left",
} as const;

export type BorderPosition =
  (typeof BorderPositions)[keyof typeof BorderPositions];

export const QrCodeBorder = ({ position }: { position: BorderPosition }) => {
  const getPositionProperties = () => {
    switch (position) {
      case BorderPositions.TOP_LEFT:
        return "top-0 left-0";
      case BorderPositions.TOP_RIGHT:
        return "top-0 right-0";
      case BorderPositions.BOTTOM_RIGHT:
        return "bottom-1 right-0";
      default:
        return "bottom-1 left-0";
    }
  };

  const getVerticalBorderProperty = () => {
    switch (position) {
      case BorderPositions.TOP_LEFT:
      case BorderPositions.TOP_RIGHT:
        return "border-t-[3px]";
      default:
        return "border-b-[3px]";
    }
  };

  const getHorizontalBorderProperty = () => {
    switch (position) {
      case BorderPositions.TOP_LEFT:
      case BorderPositions.BOTTOM_LEFT:
        return "border-l-[3px]";
      default:
        return "border-r-[3px]";
    }
  };

  const getRoundedBorderProperty = () => {
    switch (position) {
      case BorderPositions.TOP_LEFT:
        return "rounded-tl-sm";
      case BorderPositions.TOP_RIGHT:
        return "rounded-tr-sm";
      case BorderPositions.BOTTOM_RIGHT:
        return "rounded-br-sm";
      default:
        return "rounded-bl-sm";
    }
  };

  return (
    <div
      className={cn(
        "absolute z-20 h-4 w-4 border-black",
        getPositionProperties(),
        getVerticalBorderProperty(),
        getHorizontalBorderProperty(),
        getRoundedBorderProperty()
      )}
    />
  );
};

export const QrCodeBorders = () => (
  <>
    {Object.values(BorderPositions).map((position: BorderPosition) => (
      <QrCodeBorder key={position} position={position} />
    ))}
  </>
);
